import {
  RESET_SEARCH_PAGE_COMPONENTS,
  RESET_SELECTED_TXNS,
  SET_SELECTED_TXNS,
  SET_SELECTED_TXN_STATUS,
  SET_TABLE_VISIBILITY,
} from "../action";

export const setSelectedTransactions = (selectedTransactions) => {
  return (dispatch) => {
    dispatch({ type: SET_SELECTED_TXNS, payload: selectedTransactions });
  };
};

export const setTableVisibility = (isTableVisible) => {
  return (dispatch) => {
    dispatch({ type: SET_TABLE_VISIBILITY, payload: isTableVisible });
  };
};

export const setSelectedTxnStatus = (selectedTxnStatus) => {
  return (dispatch) => {
    dispatch({ type: SET_SELECTED_TXN_STATUS, payload: selectedTxnStatus });
  };
};

export function resetSearchPageComponents(type) {
  if (type === "selectedTxns") {
    return (dispatch) => {
      dispatch({ type: RESET_SELECTED_TXNS });
    };
  } else {
    return (dispatch) => {
      dispatch({ type: RESET_SEARCH_PAGE_COMPONENTS });
    };
  }
}
